import React, { useState } from 'react';

import TextInput from "../../../component/input/TextInput";
import ModalTemplate from "../../../component/modal/ModalTemplate";
import Loading from "../../../component/loading/Loading";

import * as apiUtil from "../../../util/apiUtil";
import { aesEncrypt } from "../../../util/aes256";
import { PRIMARY_BTN, SECONDARY_BTN, INPUT, LABEL, LIST, FOOTER_END } from "./modalStyle";

interface ChangePasswordModalProps {
    isOpen: boolean;
    onRequestClose: () => void;
}

const ChangePasswordModal: React.FC<ChangePasswordModalProps> = ({ isOpen, onRequestClose }) => {
    const [loading, setLoading] = useState(false);
    const [nowPassword, setNowPassword] = useState('');
    const [password1, setPassword1] = useState('');
    const [password2, setPassword2] = useState('');

    const setValue = (id: string, value: string) => {
        switch (id) {
            case "nowPassword":
                setNowPassword(value);
                break;
            case "password1":
                setPassword1(value);
                break;
            case "password2":
                setPassword2(value);
                break;
            default:
                break;
        }
    };

    const ajaxUpdatePassword = () => {
        if (!window.confirm("비밀번호를 변경하시겠습니까?")) return;
        apiUtil.asyncRequest({
            setLoading,
            url: "/api/bizchat/user/password/update",
            method: apiUtil.requestMethod.POST,
            data: {
                nowPassword: aesEncrypt(nowPassword),
                password1: aesEncrypt(password1),
                password2: aesEncrypt(password2),
            },
            success: () => {
                alert('요청하신 비밀번호로 변경되었습니다.\n보안을 위해 재로그인이 필요합니다.');
                apiUtil.signOut();
            },
        });
    };

    const handleCloseModal = () => {
        setNowPassword('');
        setPassword1('');
        setPassword2('');
        onRequestClose();
    };

    return (
        <ModalTemplate
            open={isOpen}
            handleClose={handleCloseModal}
            modalTitle="비밀번호 변경하기"
            className="react-modal"
        >
            <Loading loading={loading} />
            <div className="modal-body">
                <ul className={LIST}>
                    <li>
                        <label className={LABEL}>현재 비밀번호</label>
                        <TextInput
                            className={INPUT}
                            type="password"
                            id="nowPassword"
                            placeholder="현재 비밀번호를 입력해주세요"
                            value={nowPassword}
                            onChange={setValue}
                        />
                    </li>
                    <li>
                        <label className={LABEL}>신규 비밀번호</label>
                        <TextInput
                            className={INPUT}
                            type="password"
                            id="password1"
                            placeholder="신규 비밀번호를 입력해주세요"
                            value={password1}
                            onChange={setValue}
                        />
                    </li>
                    <li>
                        <label className={LABEL}>신규 비밀번호 확인</label>
                        <TextInput
                            onKeyDown={ajaxUpdatePassword}
                            className={INPUT}
                            type="password"
                            id="password2"
                            placeholder="신규 비밀번호를 재확인해 주세요"
                            value={password2}
                            onChange={setValue}
                        />
                    </li>
                </ul>
            </div>
            <div className={FOOTER_END}>
                <button type="button" className={PRIMARY_BTN} onClick={ajaxUpdatePassword}>확인</button>
                <button type="button" className={SECONDARY_BTN} onClick={handleCloseModal}>취소</button>
            </div>
        </ModalTemplate>
    );
};

export default ChangePasswordModal;
